import isEmpty from "lodash/isEmpty"
import {
  hasBrand,
  hasDuration,
  hasFuelType,
  hasJobType,
  hasKilometers,
  hasQuotedPrice,
  hasTransmission,
  inPriceRanges,
  isFastDelivering,
  isKind,
  inProvince
} from "./filters"

export function applyFilters(cars = [], filters) {
  const {
    brand,
    duration,
    tags,
    fuel,
    job_type,
    kilometers,
    kind,
    priceRanges,
    transmission,
    province,
    minPrice = null,
    maxPrice = null
  } = filters

  return cars.filter(
    car =>
      hasJobType(job_type, car) &&
      hasFuelType(fuel, car) &&
      hasBrand(brand, car) &&
      isKind(kind, car) &&
      hasDuration(duration, car) &&
      hasKilometers(kilometers, car) &&
      hasTransmission(transmission, car) &&
      inPriceRanges(priceRanges, car) &&
      hasQuotedPrice(minPrice, maxPrice, car) &&
      isFastDelivering(tags, car) &&
      inProvince(province, car)
  )
}

export default function filterCars(cars, filters, hasFilter) {
  if (!hasFilter || isEmpty(filters)) return cars

  return applyFilters(cars, filters)
}
